// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"sP-z","categoryName":"tP-z","categoryNameSearchHeader":"uP-z","categoryContent":"vP-z","bottomAligned":"wP-z","image":"xP-z","imageNoBackground":"yP-z"};